import _ from "lodash";
import { CaptionFrame } from "./types";

/**
 * Return transcript in string form
 */
export function formatTranscriptPunctuation(captionFrames: CaptionFrame[]) {
  return _.reduce(
    captionFrames,
    (prevValue: string, frame: CaptionFrame) => {
      const transcript = frame.transcript;
      const joinPrefix =
        beginsWithPunctuation(transcript) && !_.isEmpty(prevValue) ? "" : " ";
      return `${prevValue}${joinPrefix}${transcript}`;
    },
    ""
  );
}

export const beginsWithPunctuation = (text: string) => {
  return !!text[0]?.match(/.*?[?!.,]"?/g);
};
